import { connect } from 'react-redux';

export default function makeConnect(mapStateToProps, mapDispatchToProps) {

	function use(Component) {
	  return connect(
	    mapStateToProps,
	    mapDispatchToProps,
	  )(Component);
	};

	// Used to allow connects to be combined
	use.mapStateToProps = mapStateToProps;
	use.mapDispatchToProps = mapDispatchToProps;

	return use;
	
}



// WEBPACK FOOTER //
// ./src/utils/makeConnect.js